import { render, staticRenderFns } from "./isr-por-pago-de-ptu.vue?vue&type=template&id=11a05fb4&lang=html&"
import script from "./isr-por-pago-de-ptu.vue?vue&type=script&lang=js&"
export * from "./isr-por-pago-de-ptu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports